module.exports = __webpack_public_path__ + "assets/img/group-message.c78ee9ce.svg";